import { render, staticRenderFns } from "./dexam.vue?vue&type=template&id=43e1a561&scoped=true&"
import script from "./dexam.vue?vue&type=script&lang=js&"
export * from "./dexam.vue?vue&type=script&lang=js&"
import style0 from "./dexam.vue?vue&type=style&index=0&id=43e1a561&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e1a561",
  null
  
)

export default component.exports